export default "__VITE_ASSET__DxI16aCK__"